import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'companySizeFieldContainer',
    'targetedMainDepartmentNameInput',
    'associationSizeFieldContainer',
    'activityFreeNameInput',
    'leadActivityCategoryFieldContainer'
  ]

  onOrganizationTypeChange(event) {
    this.toggleEnableContainer(this.companySizeFieldContainerTarget, false)
    this.toggleEnableContainer(this.associationSizeFieldContainerTarget, false)

    switch (event.currentTarget.value) {
      case 'individual':
        if (this.hasLeadActivityCategoryFieldContainerTarget) {
          $(this.leadActivityCategoryFieldContainerTarget.querySelector('select')).val('other').trigger('change.select2')
        }

        break;
      case 'company':
        this.toggleEnableContainer(this.companySizeFieldContainerTarget, true)

        break;
      case 'association':
        this.toggleEnableContainer(this.associationSizeFieldContainerTarget, true)

        if (this.hasLeadActivityCategoryFieldContainerTarget) {
          $(this.leadActivityCategoryFieldContainerTarget.querySelector('select')).val('association').trigger('change.select2')
        }

        break;
      case 'public_entity':
        if (this.hasLeadActivityCategoryFieldContainerTarget) {
          $(this.leadActivityCategoryFieldContainerTarget.querySelector('select')).val('public_entity').trigger('change.select2')
        }

        break;
    }
  }

  onTargetedMainCityChange(event) {
    const select2Data = $(event.currentTarget).select2('data')[0]

    const departmentName = select2Data.department_name || event.currentTarget.options[event.currentTarget.selectedIndex].dataset.departmentName
    this.targetedMainDepartmentNameInputTarget.value = departmentName || ''
  }

  onJobChange(event) {
    if (this.hasActivityFreeNameInputTarget && this.activityFreeNameInputTarget.value == '' && event.currentTarget.value != '') {
      this.activityFreeNameInputTarget.value = event.currentTarget.options[event.currentTarget.selectedIndex].text
    }
  }

  toggleEnableContainer(container, enabled) {
    enabled ? container.classList.remove('hide') : container.classList.add('hide')
    container.querySelector('select, input, textarea').disabled = !enabled
  }
}
